import React from "react";
import PropTypes from "prop-types";

const shapes = {
  round: "rounded-[16px]",
};
const variants = {
  tarOutlineBluegray50019: "!border-blue_gray-500_19 border-[1.58px] border-solid bg-white",
  tarOutlineBluegray500ad: "!border-blue_gray-500_ad border-[1.58px] border-solid bg-white",
  tarOutlineGray20001: "!border-gray-200_01 border-[1.33px] border-solid bg-white",
};
const sizes = {
  sm: "h-[202px] p-6 text-[20px]",
  xs: "h-[140px] p-5 text-[20px]",
};

const TextArea = React.forwardRef(
  (
    {
      className = "",
      name = "",
      placeholder = "",
      shape,
      size = "xs",
      variant = "tarOutlineGray20001",
      onChange,
      ...restProps
    },
    ref,
  ) => {
    const handleChange = (e) => {
      // Pass the whole event to the parent component
      if (onChange) onChange(e); // e is the full event, including target, name, and value
    };

    return (
      <textarea
        ref={ref}
        className={`${className} ${shape && shapes[shape]} ${size && sizes[size]} ${variant && variants[variant]}`}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        {...restProps}
      />
    );
  },
);

TextArea.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  shape: PropTypes.oneOf(["round"]),
  size: PropTypes.oneOf(["sm", "xs"]),
  variant: PropTypes.oneOf(["tarOutlineBluegray50019", "tarOutlineBluegray500ad", "tarOutlineGray20001"]),
};

export { TextArea };
